<template lang="pug">
transition(name="fade")
  header(:class="{ 'is-in-root': isInRoot }" v-if="!isGestionDeContenidoOrRedmineMap()")
    .participa-level(v-if="headerIsHidden")
      .participa-link-container.header-max-container
        .participa-link.right-panel
          SharePanelWithProjectList.participa(header :projectInfo="{ name: '', code: '', }" :isParticipaPage="true")
          .search-control-container
            .search-control
              input(placeholder="Buscar" v-model="search")
              span
                v-icon(dark) search
            SearcherList(@clearSearch="search=''" :isInHeader="true")
    .programs-level(v-if="headerIsHidden")
      .programs-container.header-max-container
        .programs-icon
          v-btn.to-home(round depressed large color="white" to :href="hrefify({ name: 'home' })")
            i.asucostera-logo.ap-Asu-costera
        .programs-links.right-panel
          v-btn(round depressed outline color="primary" to :class="{ 'v-btn--active': isSolucionDefinitiva }" :href="hrefify(solucionDefinitiva)") SOLUCIÓN DEFINITIVA
          v-btn(round depressed outline color="primary" to :class="{ 'v-btn--active': isSolucionACortoPlazo }" :href="hrefify(solucionACortoPlazo)") SOLUCIÓN A CORTO PLAZO

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import inRootMixin from '@/mixins/in-root.js'

export default {
  mixins: [ inRootMixin ],
  components: {
    SharePanelWithProjectList: _ => import('@/components/participa/SharePanelWithProjectList'),
    SearcherList: _ => import('@/components/utils/SearcherList')
  },
  data: () => ({
    search: '',
    solucionDefinitiva: { name: 'map' },
    solucionACortoPlazo: { name: 'map', query: { ver: 'refugios' } }
  }),
  computed: {
    ...mapGetters([
      'isRedmineMap',
      'isRequiresAuth',
      'hrefify',
      'isMapView',
      'isSolucionACortoPlazo',
      'isSolucionDefinitiva'
    ]),
    ...mapGetters({
      state: 'interfaceState',
      headerIsHidden: 'getShowHeader'
    })
  },
  methods: {
    ...mapActions([
      'hiddenHeaderInMobileMapView',
      'setSearchText'
    ]),
    getClass (routeObj) {
      return { 'v-btn--active': this.isCurrentRoute(routeObj) }
    },
    isGestionDeContenido () {
      return this.isRequiresAuth(this.$route) || this.isCurrentRoute({ name: 'login' })
    },

    hiddenHeader () {
      return (this.isMapView || this.isSolucionACortoPlazo || this.isSolucionDefinitiva) && window.innerWidth <= 767
    },

    isGestionDeContenidoOrRedmineMap () {
      return this.isRedmineMap(this.$route) || this.isRequiresAuth(this.$route) || this.isCurrentRoute({ name: 'login' })
    }
  },
  watch: {
    isMobile (newValue) {
      this.hiddenHeaderInMobileMapView()
    },
    search (newValue) {
      this.setSearchText(newValue)
    }
  }
}

</script>

<style lang="stylus" scoped>
  @import '~@/styles/variables'

  header
    width: 100%
    position: absolute
    top: 0
    left: 0
    z-index: 1000
    box-shadow: 0px 6px 20px 0px rgba(0,0,0,0.10)
    .participa-level
      background-color: #0d2563
    .header-max-container
      max-width: 80%
      margin: 0 auto
      display: flex
      justify-content: space-between
      align-items: center
      &.participa-link-container
        justify-content: flex-end
        height: $header1-height
    .right-panel
      width: $f640px

      &:focus-within,
      &:active
        .participa
          margin-right: $f5px
        .search-control-container
          padding-left: $f5px

    .participa-link
      display: flex
      align-items: center
      .participa
        margin-right: $f5px

    .search-control-container
      border-left: 1px solid white
      flex-grow: 1
      height: $participa-icon-size
      max-width: 16.6rem
      padding-left: $f5px

    .search-control
      border: 1px solid white
      border-radius: $f20px
      padding: 0 $f20px
      height: 100%
      color: white
      display: flex
      input
        width: 100%
        &:focus
          outline: none

    .v-list
      border-radius: 10px
      max-width: 264px
      max-height: 210px
      overflow-y: scroll
      position: relative
      z-index: 1000

    .programs-container
      height: $header2-in-pages-height

    .programs-level
      background-color: rgba(255, 255, 255, .85)
      .to-home
        text-decoration: none
        &.v-btn
          background-color: transparent !important
          height: $f45px
        .asucostera-logo
          color: $color_5
          font-size: $f43px
      .programs-icon
        .v-btn
          &.v-btn--active
            &:before
              background-color: white !important
          &:hover
            background-color: #e5e5e5 !important
      .programs-links
        display: flex
        justify-content: space-between
        align-items: center
        max-width: $f500px
        a
          text-decoration: none
        .v-btn
          margin: 0
          &.v-btn--active
            background-color: $color_0 !important
            & >>> .v-btn__content
              color: white
          &.v-btn--outline
            border-width: 2px
          & >>>
            .v-btn__content
              font-family: Raleway
              font-weight: bold
    &.is-in-root
      .programs-container
        height: $header2-in-root-height
      .programs-level
        background-color: white
      .to-home
        height: $f70px
        border-radius: $f35px
        &.v-btn
          height: $f65px
        .asucostera-logo
          font-size: $f63px

  .fade-enter-active, .fade-leave-active
    transition-property: opacity max-height
    transition-duration: 0.5s
    max-height: $f500px
    will-change: opacity max-height

  .fade-enter, .fade-leave-to
    opacity: 0
    max-height: 0

  @media screen and (max-width: 850px)
    .participa-link.right-panel
      justify-content: center;
    .programs-links.right-panel, .search-control-container
      display: none !important;
    .programs-container
      justify-content: center !important;
    .programs-container.header-max-container
      height: 3rem !important;
    .asucostera-logo.ap-Asu-costera
      font-size: 2rem !important;
  @media (max-width: 600px)
    .share-panel-with-project-list.participa
      margin: 0 !important;
    header .header-max-container
      max-width: 100% !important;

</style>
